import React from "react";
import Loader from "../Loader";
import styles from "./styles.module.scss";

const UnknownViewState = () => (
  <div className={styles.unknownContainer}>
    <Loader width={64} height={64} />
    <p>Loading...</p>
  </div>
);

UnknownViewState.displayName = "UnknownViewState";

export default UnknownViewState;
